const Designer = () => {
  return (
    <div style={{ color: "white", position: "absolute", padding: 16, bottom: 0, right: 0 }}> 
      designed by <a href="https://dribbble.com/Rizkyedriansyah" target="_blank">Rizky</a> on <a href="https://dribbble.com/shots/4241423-Exchanger-landing-page" target="_blank">Dribble</a>
    </div>
  )
}

export default Designer;